<script lang="ts" setup>
import type { DropdownMenuItem } from '@nuxt/ui';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccessDisplayNames, useAuth, useSessionEnd } from '#layers/access/public';

const { t } = useI18n();
const { currentUser } = storeToRefs(useAuth());
const { getUserDisplayName } = useAccessDisplayNames();
const { logout } = useSessionEnd();

// Onboarding does not open the settings overlay, so logging out is the only account action here.
const items = computed<DropdownMenuItem[]>(() => [
	{ label: t('account.logout'), onSelect: () => logout() },
]);
</script>

<template>
	<DDropdownMenu
		v-if="currentUser"
		:items
		:content="{ side: 'bottom', align: 'end' }"
	>
		<DButton
			variant="ghost"
			color="neutral"
			trailing-icon="lucide:chevron-down"
			:aria-label="getUserDisplayName(currentUser)"
			:ui="{
				base: 'group gap-2 select-none',
				trailingIcon: 'transition-transform duration-200 group-data-[state=open]:rotate-180',
			}"
		>
			<template #leading>
				<UserAvatar :user="currentUser" class="size-8" />
			</template>
			<div class="hidden flex-col items-start sm:flex">
				<span class="text-sm font-semibold">{{ getUserDisplayName(currentUser) }}</span>
				<span v-if="currentUser.fullName" class="text-xs text-muted">{{ currentUser.email }}</span>
			</div>
		</DButton>
	</DDropdownMenu>
</template>
